import moment from 'moment';

import MS from 'constants/time/ms.const';
import { fromAnyDateToTimestamp } from 'utils/converters/time/from.util';
import zonedMoment from 'utils/date/zonedMoment.util';

const snapToMinute = (timestamp) => Math.floor((fromAnyDateToTimestamp(timestamp) % MS.day) / MS.minute) * MS.minute;

const checkIfCurrentTimeSlot = (options) => {
  const weekCurrent = moment(options?.current).week();
  const weekSlot = moment(options?.slot).week();

  if (weekCurrent !== weekSlot) return false;

  const current = snapToMinute(zonedMoment(options?.tz, options?.current));
  const slotBgn = snapToMinute(options?.slot);

  if (current < slotBgn) return false;

  const slotMinutes = options?.length ?? 15;
  const slotEnd = slotBgn + MS.minute * slotMinutes;

  return current < slotEnd;
};

export default checkIfCurrentTimeSlot;
